import { render, staticRenderFns } from "./FlexBubble.vue?vue&type=template&id=f90add2a&"
import script from "./FlexBubble.vue?vue&type=script&lang=js&"
export * from "./FlexBubble.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports